import { useState, useEffect } from 'react';
import { formatPositionsDisplay } from '../../services/positionAPIs';
import {
  Card,
  CardHeader,
  CardContent,
  Collapse,
  Typography,
  Chip,
  IconButton,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  useTheme
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PeopleIcon from '@mui/icons-material/People';

const AbsenceCard = ({ highAbsences, number, loading, sickN }) => {
  const [expanded, setExpanded] = useState({
    lateness: true,
    personal: true,
    sickness: true,
  });

  useEffect(() => {
    if (loading) {
      setExpanded({
        lateness: true,
        personal: true,
        sickness: true,
      });
    }
  }, [loading]);

  const handleToggle = (key) => {
    if (!loading) {
      setExpanded((prev) => ({
        ...prev,
        [key]: !prev[key],
      }));
    }
  };

  const theme = useTheme();

  const sections = [
    {
      key: 'lateness',
      title: `Employees Frequently Late (>${number} occasions)`,
      data: highAbsences.latenessEmployees,
      color: theme.palette.warning.main,
    },
    {
      key: 'personal',
      title: `Employees with >${number} PC Occasions`,
      data: highAbsences.personalEmployees,
      color: theme.palette.info.main,
    },
    {
      key: 'sickness',
      title: `Frequent Absentees (>${sickN} sick occasions)`,
      data: highAbsences.sicknessEmployees,
      color: theme.palette.error.main,
    },
  ];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 3,
        mt: 3,
        mb: 2,
        background: 'transparent',
      }}
    >
      {sections.map((section) => (
        <Card
          key={section.key}
          sx={{ display: 'flex', flexDirection: 'column', height: '100%', background: 'transparent' }}
        >
          <CardHeader
            avatar={<PeopleIcon sx={{ color: section.color }} />}
            title={
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {section.title}
              </Typography>
            }
            action={
              <>
                <Chip
                  label={`${section.data.length} ${section.data.length === 1 ? 'employee' : 'employees'}`}
                  size="small"
                  sx={{
                    backgroundColor: section.color,
                    color: 'white',
                    fontWeight: 500,
                    mr: 1,
                  }}
                />
                <IconButton onClick={() => handleToggle(section.key)}>
                  <ExpandMoreIcon
                    sx={{
                      transform: expanded[section.key] ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.2s',
                    }}
                  />
                </IconButton>
              </>
            }
            sx={{
              bgcolor: 'background.paper',
              borderLeft: `4px solid ${section.color}`,
              borderBottom: 1,
              borderColor: 'divider'
            }}
          />
          <Collapse in={expanded[section.key]} timeout="auto" unmountOnExit>
            <CardContent sx={{ flexGrow: 1, p: 0 }}>
              {section.data.length > 0 ? (
                <TableContainer component={Paper} elevation={0}>
                  <Table>
                    <TableHead>
                      <TableRow sx={{ bgcolor: 'action.hover' }}>
                        <TableCell sx={{ fontWeight: 600 }}>Full Name</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Position</TableCell>
                        <TableCell sx={{ fontWeight: 600 }}>Count</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {section.data
                        .slice()
                        .sort((a, b) => b.absenceCount - a.absenceCount)
                        .map((employee) => (
                          <TableRow key={employee.employeeId}>
                            <TableCell>{employee.fullName}</TableCell>
                            <TableCell>{formatPositionsDisplay(employee)}</TableCell>
                            <TableCell align="center">
                              <Chip
                                label={employee.absenceCount}
                                color="error"
                                size="small"
                                sx={{ fontWeight: 600 }}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Box sx={{ padding: 4, textAlign: 'center', color: '#999' }}>
                  <PeopleIcon sx={{ fontSize: 48, color: '#ddd', marginBottom: 1 }} />
                  <Typography variant="body2">
                    No employees in this category
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Collapse>
        </Card>
      ))}
    </Box>
  );
};

export default AbsenceCard;

// import { useState, useEffect } from 'react';
// import {
//   Card,
//   CardHeader,
//   CardContent,
//   Collapse,
//   Typography,
//   Chip,
//   IconButton,
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   TableContainer,
//   Paper
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import PeopleIcon from '@mui/icons-material/People';

// const AbsenceCard = ({ highAbsences, number, loading, sickN }) => {
//   const [expanded, setExpanded] = useState(false);

//   useEffect(() => {
//     if (loading) {
//       setExpanded(true);
//     }
//   }, [loading]);

//   const handleToggle = () => {
//     if (!loading) setExpanded(!expanded);
//   };

//   const sections = [
//     {
//       key: 'lateness',
//       title: `Employees Frequently Late (>${number} occasions)`,
//       data: highAbsences.latenessEmployees,
//       color: '#ff9800'
//     },
//     {
//       key: 'personal',
//       title: `Employees with >${number} PC Occasions`,
//       data: highAbsences.personalEmployees,
//       color: '#2196f3'
//     },
//     {
//       key: 'sickness',
//       title: `Frequent Absentees (>${sickN} sick occasions)`,
//       data: highAbsences.sicknessEmployees,
//       color: '#f44336'
//     }
//   ];

//   return (
//     <Box
//       sx={{
//         display: 'grid',
//         gridTemplateColumns: 'repeat(3, 1fr)',
//         gap: 3,
//         mt: 3,
//         mb: 2
//       }}
//     >
//       {sections.map((section) => (
//         <Card
//           key={section.key}
//           sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
//         >
//           <CardHeader
//             avatar={<PeopleIcon sx={{ color: section.color }} />}
//             title={
//               <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                 {section.title}
//               </Typography>
//             }
//             action={
//               <>
//                 <Chip
//                   label={`${section.data.length} ${section.data.length === 1 ? 'employee' : 'employees'}`}
//                   size="small"
//                   sx={{
//                     backgroundColor: section.color,
//                     color: 'white',
//                     fontWeight: 500,
//                     mr: 1
//                   }}
//                 />
//                 <IconButton onClick={handleToggle}>
//                   <ExpandMoreIcon
//                     sx={{
//                       transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
//                       transition: 'transform 0.2s'
//                     }}
//                   />
//                 </IconButton>
//               </>
//             }
//             sx={{
//               backgroundColor: '#fafafa',
//               borderLeft: `4px solid ${section.color}`
//             }}
//           />
//           <Collapse in={expanded} timeout="auto" unmountOnExit>
//             <CardContent sx={{ flexGrow: 1, p: 0 }}>
//               {section.data.length > 0 ? (
//                 <TableContainer component={Paper} elevation={0}>
//                   <Table>
//                     <TableHead>
//                       <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//                         {/* <TableCell sx={{ fontWeight: 600 }}>Employee ID</TableCell> */}
//                         <TableCell sx={{ fontWeight: 600 }}>Full Name</TableCell>
//                         <TableCell sx={{ fontWeight: 600 }}>Position</TableCell>
//                         {/* <TableCell sx={{ fontWeight: 600 }}>Department</TableCell> */}
//                         <TableCell sx={{ fontWeight: 600 }}>Count</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {section.data.map((employee) => (
//                         <TableRow key={employee.employeeId}>
//                           {/* <TableCell>{employee.employeeId}</TableCell> */}
//                           <TableCell>{employee.fullName}</TableCell>
//                           <TableCell>{employee.position}</TableCell>
//                           {/* <TableCell>{employee.department}</TableCell> */}
//                           <TableCell align='center'>
//                             <Chip
//                               label={employee.absenceCount}
//                               color="error"
//                               size="small"
//                               sx={{ fontWeight: 600 }}
//                             />
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               ) : (
//                 <Box sx={{ padding: 4, textAlign: 'center', color: '#999' }}>
//                   <PeopleIcon sx={{ fontSize: 48, color: '#ddd', marginBottom: 1 }} />
//                   <Typography variant="body2">
//                     No employees in this category
//                   </Typography>
//                 </Box>
//               )}
//             </CardContent>
//           </Collapse>
//         </Card>
//       ))}
//     </Box>
//   );
// };

// export default AbsenceCard;

// import { useState } from 'react';
// import {
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Typography,
//   Chip,
//   Box
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import PeopleIcon from '@mui/icons-material/People';

// const AbsenceAccordion = ({ highAbsences, number, loading }) => {
//   const sections = [
//     {
//       key: 'lateness',
//       title: `Employees Frequently Late (>${number} occasions)`,
//       data: highAbsences.latenessEmployees,
//       color: '#ff9800'
//     },
//     {
//       key: 'personal',
//       title: ` Employees with >${number} PC Occasions`,
//       data: highAbsences.personalEmployees,
//       color: '#2196f3'
//     },
//     {
//       key: 'sickness',
//       title: `Frequent Absentees (>${number} sick occasions)`,
//       data: highAbsences.sicknessEmployees,
//       color: '#f44336'
//     }
//   ];

//   return (
//     <Box sx={{ maxWidth: '100%', mt:3, mb:2, padding: 0, display:'flex', gap:3 }}>
//       {sections.map(section => (
//         <Accordion key={section.key} sx={{ marginBottom: 2, width:'33%' }}>
//           <AccordionSummary
//             expandIcon={<ExpandMoreIcon />}
//             sx={{
//               backgroundColor: '#fafafa',
//               borderLeft: `4px solid ${section.color}`,
//               '&:hover': {
//                 backgroundColor: '#f5f5f5'
//               }
//             }}
//           >
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
//               <PeopleIcon sx={{ color: section.color }} />
//               <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                 {section.title}
//               </Typography>
//               <Chip
//                 label={`${section.data.length} ${section.data.length === 1 ? 'employee' : 'employees'}`}
//                 size="small"
//                 sx={{
//                   backgroundColor: section.color,
//                   color: 'white',
//                   fontWeight: 500,
//                   ml:'auto'
//                 }}
//               />
//             </Box>
//           </AccordionSummary>
//           <AccordionDetails sx={{ padding: 0 }}>
//             {section.data.length > 0 ? (
//               <TableContainer component={Paper} elevation={0}>
//                 <Table>
//                   <TableHead>
//                     <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
//                       <TableCell sx={{ fontWeight: 600 }}>Employee ID</TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>Full Name</TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>Position</TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>Department</TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>Absence Count</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {section.data.map((employee) => (
//                       <TableRow
//                         key={employee.employeeId}
//                         sx={{
//                           '&:hover': {
//                             backgroundColor: '#fafafa'
//                           }
//                         }}
//                       >
//                         <TableCell>{employee.employeeId}</TableCell>
//                         <TableCell>{employee.fullName}</TableCell>
//                         <TableCell>{employee.position}</TableCell>
//                         <TableCell>{employee.department}</TableCell>
//                         <TableCell>
//                           <Chip
//                             label={employee.absenceCount}
//                             color="error"
//                             size="small"
//                             sx={{ fontWeight: 600 }}
//                           />
//                         </TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             ) : (
//               <Box
//                 sx={{
//                   padding: 4,
//                   textAlign: 'center',
//                   color: '#999'
//                 }}
//               >
//                 <PeopleIcon sx={{ fontSize: 48, color: '#ddd', marginBottom: 1 }} />
//                 <Typography variant="body2">
//                   No employees in this category
//                 </Typography>
//               </Box>
//             )}
//           </AccordionDetails>
//         </Accordion>
//       ))}
//     </Box>
//   );
// };

// export default AbsenceAccordion;